import React from 'react';

const KEY = 'selectedVehicle';
const EVENT = 'vehicle-changed';
const SYNC_EVENT = 'vehicle-sync';
let lastTracked = '';
// Anonymous popularity signal (fire-and-forget, once per brand+model per page session)
const trackSelection = (vehicle) => {
  if (!vehicle?.brand || !vehicle?.model) return;
  const key = `${vehicle.brand}|${vehicle.model}`;
  if (key === lastTracked) return;
  lastTracked = key;
  try {
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/vehicles/track`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ brand: vehicle.brand, model: vehicle.model }), keepalive: true }).catch(() => {});
  } catch { /* ignore */ }
};

export const vehicleStore = {
  get: () => {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || null;
    } catch {
      return null;
    }
  },
  // `silent` skips the account sync (used when restoring from the account itself)
  set: (vehicle, { silent = false } = {}) => {
    localStorage.setItem(KEY, JSON.stringify(vehicle));
    window.dispatchEvent(new Event(EVENT));
    if (!silent) window.dispatchEvent(new CustomEvent(SYNC_EVENT, { detail: vehicle }));
    trackSelection(vehicle);
  },
  clear: () => {
    localStorage.removeItem(KEY);
    window.dispatchEvent(new Event(EVENT));
  },
  subscribe: (callback) => {
    window.addEventListener(EVENT, callback);
    return () => window.removeEventListener(EVENT, callback);
  },
  onSync: (callback) => {
    const h = (e) => callback(e.detail);
    window.addEventListener(SYNC_EVENT, h);
    return () => window.removeEventListener(SYNC_EVENT, h);
  },
  same: (a, b) => !!a && !!b && a.brand === b.brand && a.model === b.model && a.year === b.year && (a.engine?.name || null) === (b.engine?.name || null),
  label: (vehicle) => (vehicle ? `${vehicle.brand} ${vehicle.model} (${vehicle.year}) · ${vehicle.engine?.name}` : ''),
  toParams: (vehicle) => (vehicle ? {
    brand: vehicle.brand,
    model: vehicle.model,
    fuel: vehicle.engine?.fuel,
    engine: vehicle.engine?.name,
  } : null),
};

export const useSelectedVehicle = () => {
  const [vehicle, setVehicle] = React.useState(vehicleStore.get);
  React.useEffect(() => vehicleStore.subscribe(() => setVehicle(vehicleStore.get())), []);
  return vehicle;
};
